module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAA9klEQVQ4T+2UMRKCMBRE91soF9BRzmCppY12eiGkogIupJ02llpyBnH0Akjhd0IGJ0Ag6Ghn6p/3N7s7IXz50Jd5aAUMzuFBLF7bzswkoBXQPwcsQK69Ns4bBwToD2zM5bceinowwUopWXlD75pL0YXiXbxBl60NMRK1TgWFfhwewTwBIUrpvsihZaCE9XZgjEF0ckfONF9eAvp9gPZyEBHAc3fk3lSgH+tntMCsc5oLYJLPJx7oFqopaUOpQIXiDIiorL4ceW3KBWhRwssKXX8aa1OBKr7WldHYQwntbCXgsRQhNTXbCDR9V609fBdUW5tPQfm9J4+uiRUB5FEjAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/down.png
// module id = w80D
// module chunks = 1